import React, { useRef, useEffect, useState } from 'react';
import './userChat.css';
import ChatReportPreview from './chatReportPreview/chatReportPreview';
import UploadMyReports from './uploadMyReports/uploadMyReports';
import { useSelector, useDispatch } from 'react-redux';
import { getAttachmentbyFileId } from 'apiServices/reducer/apiService';
import pdfLogo from 'assets/images/logo/pdf.png';
import { saveReportDocumentChat, updateACMEReadMessage } from 'apiServices/reducer/apiService';
import icon128 from 'assets/icons/icon-128x128.png';
import { MedicalHelp } from 'assets';



const LiveChat = ({
  lstMsgs = [],
  selectedFile,
  newMessage,
  isRecording,
  viewHistory,
  endChat,
  openSettings,
  hideChat,
  handleReportSelected,
  chatData,
  onRefresh,
  setNewMessage,
  sendMessage,
  startSpeechRecognition,
  stopSpeechRecognition,
}) => {
  const fileInput = useRef(null);
  const chatBodyRef = useRef(null);
  const [showReportPreview, setShowReportPreview] = useState(false);
  const [uploadFromMyComputer, setUploadFromMyComputer] = useState(false);
  const [value, setValue] = useState("");
  const dispatch = useDispatch();
  const token = useSelector((state) => state.apiService.token);
  const [fileIndex, setFileIndex] = useState("");

  useEffect(() => {
    //console.log(lstMsgs, "for chat history")
    // Scroll to bottom when messages change
    if (chatBodyRef.current) {
      chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
    }
    if (chatData && chatData.length > 0) {
    dispatch(updateACMEReadMessage({
      token: token,
      loginUserId: currentUser?.user_id,
      chatId: chatData && chatData.length > 0 ?
        (chatData[0].chat_id || 0) :
        (lstMsgs && lstMsgs.length > 0 ? lstMsgs[0].chat_id || 0 : 0),
      isread: true
    })).then((response) => {
      console.log(response, "response from updateACMEReadMessage")
    })
  }
  }, [lstMsgs.length])
  const [showHeaderOptions, setShowHeaderOptions] = useState(false)
  const [showUploadMyReports, setShowUploadMyReports] = useState(false)
  const [showAttachmentOptions, setShowAttachmentOptions] = useState(false)
  const [pdfUrl, setPDFURL] = useState(null);
  const [imageUrl, setImageURL] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [isUploadingFromMyComputer, setIsUploadingFromMyComputer] = useState(false);
  const currentUser = useSelector((state) => state.apiService.login);
  const toggleHeaderOptions = () => {
    setShowHeaderOptions(!showHeaderOptions)
  }
  const speakMessage = (message) => {
    const utterance = new SpeechSynthesisUtterance(message);
    window.speechSynthesis.speak(utterance);
  }

  const handleFileUpload = (e) => {
    console.log(e, "for file upload")
    const file = e.target.files[0];
    setShowAttachmentOptions(true);
    if (file) {
      setValue(file.name);
      setUploadedFiles(file);
      console.log("File uploaded:", file);
      setShowAttachmentOptions(false);
      setUploadFromMyComputer(true);
    }
  }
  const handleFileUploadtoChat = () => {
    console.log(uploadedFiles, "for uploaded files")
    const messageType = uploadedFiles.type === "application/pdf" ? "2" : "3";
    if (!uploadedFiles) {
      console.error('No file selected');
      return;
    }

    try {
      const formData = new FormData();
      // Append the actual file
      //  formData.append('file', uploadedFiles);
      formData.append('fileName', uploadedFiles.name);
      formData.append('filePath', '/uploads/' + uploadedFiles.name);
      formData.append('token', token);
      formData.append('messageType', messageType);
      formData.append('message', "");
      formData.append('senderId', currentUser?.user_id);
      // Handle empty chatData by using lstMsgs[0] as fallback, otherwise use 0
      const receiverId = chatData && chatData.length > 0 ?
        (chatData[0].provider_id || 0) :
        (lstMsgs && lstMsgs.length > 0 ? lstMsgs[0].receiver_id || 0 : 0);

      const chatId = chatData && chatData.length > 0 ?
        (chatData[0].chat_id || 0) :
        (lstMsgs && lstMsgs.length > 0 ? lstMsgs[0].chat_id || 0 : 0);

      formData.append('receiverId', receiverId);
      formData.append('chatId', chatId);
      formData.append('loginUserId', currentUser?.user_id);
      formData.append('chunk', uploadedFiles);  // Append the actual file as chunk
      formData.append('totalChunks', '1');
      formData.append('created_on', new Date().toISOString());
      formData.append('index', "0");

      // Log the FormData contents for debugging
      for (let pair of formData.entries()) {
        console.log(pair[0] + ': ' + pair[1]);
      }

      dispatch(saveReportDocumentChat(formData)).then((res) => {
        console.log(res, "response after upload");
        // Clear the uploaded files and input after successful upload
        setUploadedFiles(null);
        setValue('');
        setShowAttachmentOptions(false);
        setUploadFromMyComputer(false);
        onRefresh();
      });

    } catch (error) {
      console.error('Error uploading file:', error);
    }
  }
  const toggleAttachmentOptions = () => {
    setShowAttachmentOptions(!showAttachmentOptions)

  }

  const uploadFromMyReports = () => {
    setShowUploadMyReports(true);
    setShowAttachmentOptions(false);
  }
  const scrollToBottom = () => {
    if (chatBodyRef.current) {
      chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
    }
  }
  const openAttachmentDialog = (message) => {
    console.log(message, "for attachment")

    const params = {
      chatId: message.chat_id,
      messageId: message.message_id,
      messageType: message.message_type_id,
      senderId: message.sender_id,
      token: token
    }
    console.log(params, "for attachment")
    dispatch(getAttachmentbyFileId(params)).then((response) => {
      console.log('Raw response:', response);

      if (!response || !response.payload) {
        console.error('Invalid response format');
        return;
      }

      const resp = response.payload;
      console.log('Response type:', typeof resp);
      console.log('Response data:', resp);

      try {
        let pdfData;

        // If response is already a Blob
        if (resp instanceof Blob) {
          console.log('Response is already a Blob');
          pdfData = resp;
        }
        // If response is an object with data property
        else if (resp) {
          console.log('Response has data property');
          if (resp.data instanceof Blob) {
            pdfData = resp;
          } else if (resp instanceof ArrayBuffer) {
            console.log('Data is ArrayBuffer');
            pdfData = new Blob([resp], { type: 'application/pdf' });
          } else if (resp instanceof Uint8Array) {
            console.log('Data is Uint8Array');
            pdfData = new Blob([resp], { type: 'application/pdf' });
          } else if (typeof resp === 'string') {
            console.log('Data is string, attempting to convert to binary');
            // Convert string to binary
            const encoder = new TextEncoder();
            const bytes = encoder.encode(resp);
            pdfData = new Blob([bytes], { type: 'application/pdf' });
          } else {
            console.log('Creating blob from data property');
            pdfData = new Blob([resp], { type: 'application/pdf' });
          }
        }
        // If response is ArrayBuffer
        else if (resp instanceof ArrayBuffer) {
          console.log('Response is ArrayBuffer');
          pdfData = new Blob([resp], { type: 'application/pdf' });
        }
        // If response is Uint8Array
        else if (resp instanceof Uint8Array) {
          console.log('Response is Uint8Array');
          pdfData = new Blob([resp], { type: 'application/pdf' });
        }
        // If response is a string
        else if (typeof resp === 'string') {
          console.log('Response is string, attempting to convert to binary');
          // Convert string to binary
          const encoder = new TextEncoder();
          const bytes = encoder.encode(resp);
          pdfData = new Blob([bytes], { type: 'application/pdf' });
        }
        // If none of the above, try to create blob from raw response
        else {
          console.log('Creating blob from raw response');
          pdfData = new Blob([resp], { type: 'application/pdf' });
        }

        // Validate PDF data
        if (!pdfData || pdfData.size === 0) {
          throw new Error('Invalid PDF data: Empty or zero size');
        }

        console.log('Created PDF blob:', {
          size: pdfData.size,
          type: pdfData.type
        });

        // Create blob URL with PDF viewer parameters
        const blobUrl = URL.createObjectURL(pdfData);
        const pdfViewerUrl = `${blobUrl}#view=FitH&toolbar=1`;
        console.log('Created PDF viewer URL:', pdfViewerUrl);

        setPDFURL(pdfViewerUrl);
        setShowReportPreview(true);

      } catch (error) {
        console.error('Error processing PDF:', error);
        console.error('Error details:', {
          responseType: typeof resp,
          responseData: resp,
          error: error.message
        });
      }
    }).catch(error => {
      console.error('Error fetching attachment:', error);
    });
  }
  const openImage = (message) => {
    setPDFURL(null);
    console.log(message, "for image")
    setImageURL(message.media_path)
    setShowReportPreview(true);
  }
  const handlereportMycmoputer = () => {
    setShowReportPreview(false);
    setShowAttachmentOptions(true);
    setUploadFromMyComputer(true);
    fileInput.current?.click();
  }
  return (
    <div className="chat-window">
      <div className="chat-header">
        <div className="header-left" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <img src={MedicalHelp} alt="Medical Help Icon" style={{ width: '36px', height: '36px', background: 'white', borderRadius: '6px', border: '2px solid #d32f2f', padding: '2px' }} />
          <span className="header-title">Live Medical Help</span>
        </div>
        <div className="header-right">
          <div className="header-options">
            <div
              className="header-options-trigger"
              onClick={toggleHeaderOptions}
            >
              <i className="fa fa-ellipsis-v"></i>
            </div>
            {showHeaderOptions && (
              <div className="options-menu">
                <div className="options-menu-content">
                  <button
                    className="option-item mb-1"
                    onClick={viewHistory}
                  >
                    <span className="option-title">History</span>
                  </button>
                  <button
                    className="option-item mb-1"
                    onClick={endChat}
                  >
                    <span className="option-title">End Chat</span>
                  </button>
                  <button
                    className="option-item mb-1"
                    onClick={openSettings}
                  >
                    <span className="option-title">Settings</span>
                  </button>
                </div>
              </div>
            )}
          </div>
          <div onClick={hideChat} style={{ cursor: 'pointer' }}>
            Close
          </div>
        </div>
      </div>
      <div className="chat-body" ref={chatBodyRef}>
        {lstMsgs.length > 0 && lstMsgs.map((message, idx) => {
          const isOwnMessage = message.sender_id === currentUser.user_id;

          const messageContainerStyle = {
            display: "flex",
            flexDirection: "column",
            alignItems: isOwnMessage ? 'flex-end' : 'flex-start',
            marginBottom: "20px",
            padding: "5px",
            width: "100%"
          };

          const messageStyle = {
            display: "flex",
            flexDirection: "column",
            backgroundColor: isOwnMessage ? '#f0f0f0' : '#f0f0f0',
            padding: '12px',
            borderRadius: '12px',
            color: isOwnMessage ? 'black' : 'black',
            maxWidth: '70%',
            minWidth: '100px',
            position: 'relative',
            fontSize: '0.8rem',
            cursor: 'pointer',
            fontWeight: 'bold'
          };

          const fileCardStyle = {
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            padding: '8px',
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '8px',
            cursor: 'pointer'
          };

          return (
            <div
              key={message.message_id || idx}
              style={messageContainerStyle}
            >
              <div style={messageStyle}>
                {message.sender_id !== currentUser.user_id && (
                  <div style={{ marginBottom: '5px' }}>
                    <u><b>{message.created_by_name}</b></u>
                  </div>
                )}

                {message.message_type_id === 1 && (
                  <div style={{ wordBreak: 'break-word' }}>
                    {message.message}
                  </div>
                )}

                {message.file_name && (
                  <div style={fileCardStyle} onClick={() => openAttachmentDialog(message)}>
                    <div className="file-icon">
                      <img
                        src={pdfLogo}
                        style={{ width: '24px', height: '24px' }}
                        alt="PDF"
                      />
                    </div>
                    <div>
                      <div style={{ fontWeight: 'bold' }}>{message.file_name}</div>
                      <div style={{ fontSize: '0.8rem' }}>Click to view</div>
                    </div>
                  </div>
                )}

                {message.media_path && (
                  <img
                    src={message.media_path}
                    alt="Image Preview"
                    style={{
                      maxWidth: '100%',
                      borderRadius: '8px',
                      cursor: 'pointer'
                    }}
                    onClick={() => openImage(message)}
                  />
                )}

                <div style={{
                  fontSize: '0.75rem',
                  marginTop: '5px',
                  opacity: '0.8',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px'
                }}>
                  {message.created_on}
                  <i
                    className="fa fa-volume-up"
                    style={{ cursor: 'pointer', marginLeft: '5px', color: "black" }}
                    onClick={() => speakMessage(message.message)}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="chat-footer">
        <button className="attach-button" onClick={toggleAttachmentOptions}>
          <i className="fa fa-paperclip"></i>
        </button>
        {showAttachmentOptions && (
          <div className="attachment-options">
            <button onClick={uploadFromMyReports}>Upload from My Reports</button>
            <button onClick={handlereportMycmoputer}>Upload from this Computer</button>
            <input
              ref={fileInput}
              type="file"
              id="file-upload"
              style={{ display: 'none' }}
              onChange={handleFileUpload}
            />
          </div>
        )}
        <input
          type="text"
          value={uploadFromMyComputer ? value : newMessage}
          placeholder="Type here to chat..."
          onChange={e => showAttachmentOptions ? setValue(e.target.value) : setNewMessage(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && sendMessage()}
          className='ms-2'
        />
        <button
          className={`mic-button ${isRecording ? 'recording' : 'blue'} ms-2`}
          onClick={isRecording ? stopSpeechRecognition : startSpeechRecognition}
          title={isRecording ? 'Click to stop recording' : 'Click to start voice recognition (Ctrl+Shift+V)'}
        >
          <i className="fa fa-microphone"></i>
        </button>
        <button className={`send-button ms-2 ${newMessage.trim() === '' && value.trim() === '' ? 'disabled' : 'enabled'}`} onClick={uploadFromMyComputer ? handleFileUploadtoChat : sendMessage}>
          <i className="fa fa-paper-plane"></i>
        </button>
      </div>
      <div className="chat-footer-disclaimer">
        ACMEHealth.ai | CommerzTech (India) Pvt. Ltd. | All rights reserved
      </div>
      {showReportPreview && (
        <ChatReportPreview
          show={showReportPreview}
          onClose={() => setShowReportPreview(false)}
          fileContent={pdfUrl}
          imageContent={imageUrl}
        />
      )}
      {showUploadMyReports && (
        <UploadMyReports
          currentUser={currentUser}
          onClose={() => { setShowUploadMyReports(false); setShowAttachmentOptions(false); onRefresh(); }}
          chatData={chatData}
        //onReportSelected={handleReportSelected}
        />
      )}
    </div>
  );
};

export default LiveChat;